import { TenantSelectionMessages, TranslationTenantSelectionMessages } from "../interfaces";

export const messages: TranslationTenantSelectionMessages = {
  [TenantSelectionMessages.title]: "Seleciona el tenant al que deseas acceder",
  [TenantSelectionMessages.currentTenant]: "Tenant actual: {{currentTenantName}}",
  [TenantSelectionMessages.confirmTenantSelectionModalTitle]: "Cambio de tenant",
  [TenantSelectionMessages.confirmTenantSelectionModalContent]: "Al confirmar la selección de un nuevo tenant,"
  + " se cerrará automáticamente la sesión para aplicar los cambios. ¿Desea continuar?"
};